import { NumberInput } from '../NumberInput';

const Percent: React.FC<Parameters<typeof NumberInput>[0]> = (props) => <NumberInput prefix='%' {...props} />;

export default Percent;
